import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatestWith, map } from 'rxjs';

import { StorageService } from '@shared/core/services/storage.service';
import { AddToCartMessages } from '@shared/modules/add-cart-item/const/messages';
import { NavigationMenuService } from '@shared/services/navigation-menu.service';
import { PhoneNumbers } from '@shared/types/phone-numbers';

@Component({
  selector: 'app-service-in-diagnostic-center',
  templateUrl: './service-in-diagnostic-center.component.html',
  styleUrls: ['./service-in-diagnostic-center.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceInDiagnosticCenterComponent {
  phones$ = this.navigationMenu.isHelixLiteAvailable$.pipe(
    combineLatestWith(this.storage.companyPhone$, this.storage.federalPhone$),
    map(([isHelixLite, companyPhone, federalPhone]) =>
      isHelixLite ? null : new PhoneNumbers(companyPhone, federalPhone)
    )
  );

  message$ = this.navigationMenu.isHelixLiteAvailable$.pipe(
    map((isHelixLite) =>
      isHelixLite
        ? AddToCartMessages.CannotPreorderHelixLiteMessage
        : AddToCartMessages.CannotPreorderMessage
    )
  );

  constructor(
    private storage: StorageService,
    private navigationMenu: NavigationMenuService
  ) {}
}
